import * as React from "react";
import { Fragment, useEffect, useState } from "react";

import CheckOutForm1 from "./CheckOutForm1";
import CheckOutForm2 from "./CheckOutForm2";
import CheckOutForm3 from "./CheckOutForm3";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Step, StepLabel, Stepper } from "@mui/material";
import TradingStc from "./TradingStc";
import dayjs from "dayjs";
import { Col, Container, Row } from "react-bootstrap";
import { useShoppingCart } from "../context/ShoppingCartContext";
import CartCheckOutList from "../components/CartCheckOutList";
import { Link } from "react-router-dom";
import { axiosPrivate } from "../api/axios";
import { getSTCValues } from "../functions/getZoneAndStcValues";
import useAuth from "../hooks/useAuth";
import { Alert } from "@mui/material";

export default function CheckOutForm() {
  const { auth } = useAuth();

  const [data, setData] = useState({
    shipping: '',
    trading_stc: '0',
    is_property_owner: '1',
    registered_for_gst: '0',
    install_date: dayjs(new Date()),
    is_hws_second_hand: '',
    have_second_hw_system: '0',
    existing_hws_type: '',
    installation_building_type: '',
    installation_building_height: '',
    customer_order_no: '',
    pickup_by: '',
    pickup_by_agency: '',

    owner_firstname: '',
    owner_lastname: '',
    owner_phone: '',
    owner_email: '',
    owner_street: '',
    owner_suburb_town: '',
    owner_state: '',
    owner_postcode: '',

    install_firstname: '',
    install_lastname: '',
    install_phone: '',
    install_email: '',
    install_street: '',
    install_suburb_town: '',
    install_state: '',
    install_postcode: '',

    business_name: '',
    business_abn: '',
    location_extra_hot_water_system: '',
    order_notes: '',

    delivery_method: '',
    delivery_company: '',
    delivery_firstname: '',
    delivery_lastname: '',
    delivery_number_street: '',
    delivery_street2: '',
    delivery_suburb: '',
    delivery_state: '',
    delivery_postcode: '',
    delivery_service: '',

    stc_zone: '',
    stc_quantity: '',
    stc_price: ''
  });
  const [currentStep, setCurrentStep] = useState(0);
  const [totalSteps, setTotalSteps] = useState(0);
  const { cartItems, cartQuantity, setCartItems } = useShoppingCart();
  const [message, setMessage] = useState('');
  const [seqno, setSeqno] = useState(null);


  if (auth?.stop_credit) {
    return (
      <Container>
        <Alert severity="error" sx={{ mb: 3 }}>
          <p><strong>Account Temporarily Restricted</strong></p>
          <p>Your account is currently restricted from placing new orders due to an outstanding balance in your account</p>

          <p>Please contact our office at <strong>08 9203 1272</strong> to resolve this issue.</p>
        </Alert>
        <div className="text-center">
          <Link to="/orders/paginated" className="btn btn-outline-primary me-2">
            View Previous Orders
          </Link>
          <Link to="/" className="btn btn-primary">
            Back to Home
          </Link>
        </div>
      </Container>
    );
  }

  const dispatch = async (formData) => {
    const payLoad = { ...formData, cartItems };
    try {
      const response = await axiosPrivate.post('/api/order/create',
        JSON.stringify(payLoad)
      );

      if (response.status === 200) {
        setSeqno(response.data);
        /* order good now clear cart */
        setCartItems([]);
        toast.success(`Your order #${response.data} has been completed.`);
      }
    } catch (err) {

      let message = '';
      if (err.response.status === 401) {
        message = "Order Failed to process correctly. You have session has expired and you were logged out.";
      } else {
        message = "Order Failed to process correctly. Please notify our office if this problem persists.\n " + err.message;
      }

      setMessage(message);
      toast.error("Your order submission has failed. Please try again.")
      setCartItems([]);
      console.error("create order error: ", err.response.data)
    }

    setCurrentStep(prev => prev + 1);
  }

  const processSTC = (formData) => {

    if (formData.trading_stc !== '1') return { formData, cartItems };

    // STC eligible stock codes
    const stcEligibleProducts = [
      "H-PASHW015-270LD-R290",
      "H-PASHW008-180LD-R290"
    ];

    // Find eligible products in cart
    const eligibleItems = cartItems.filter(item =>
      stcEligibleProducts.includes(item.stockcode)
    );

    if (eligibleItems.length === 0) return { formData, cartItems };

    // Get postcode from form data (prefer owner_postcode, fallback to install_postcode)
    const postcode = formData.owner_postcode || formData.install_postcode;

    if (!postcode) {
      console.error('No postcode found for STC calculation');
      return { formData, cartItems };
    }

    let totalSTCQuantity = 0;
    let totalSTCPrice = 0;
    let stcZone = null;
    const stcProducts = [];
    let stcProductId = 999; // Starting ID for STC products

    // Calculate STC values for each eligible product separately
    eligibleItems.forEach(item => {
      const stcValues = getSTCValues(Number(postcode), item.stockcode);
      console.log(stcValues);
      if (stcValues.quantity && stcValues.price && stcValues.zone) {
        // Calculate STC values for this specific product
        const productSTCQuantity = stcValues.quantity * item.quantity;
        const productSTCPrice = stcValues.price * item.quantity;

        // Add to totals
        totalSTCQuantity += productSTCQuantity;
        totalSTCPrice += productSTCPrice;

        // Set zone from the first valid calculation
        if (!stcZone) {
          stcZone = stcValues.zone;
        }

        // Create separate STC product for this item
        const stcProduct = {
          id: stcProductId++, // Unique ID for each STC product
          stockcode: 'WS-H-STC-ASSIGNED',
          quantity: productSTCQuantity,
          price: 0
        };

        stcProducts.push(stcProduct);
      }
    });

    let updatedFormData = formData;
    let updatedCartItems = cartItems;

    // Add STC products to cart if we have valid values
    if (stcProducts.length > 0 && totalSTCQuantity > 0 && totalSTCPrice > 0) {

      // Remove existing STC products if any
      updatedCartItems = cartItems.filter(item => item.stockcode !== 'WS-H-STC-ASSIGNED');

      // Add all new STC products
      updatedCartItems = [...updatedCartItems, ...stcProducts];

      // Update form data with total STC values
      updatedFormData = {
        ...formData,
        stc_zone: stcZone,
        stc_quantity: totalSTCQuantity,
        stc_price: totalSTCPrice
      };

      // Update state for UI
      setCartItems(updatedCartItems);
      setData(prev => ({
        ...prev,
        stc_zone: stcZone,
        stc_quantity: totalSTCQuantity,
        stc_price: totalSTCPrice
      }));
    }

    return { formData: updatedFormData, cartItems: updatedCartItems };
  };

  const handleNextStep = (newData, final = false) => {
    setData(prev => ({ ...prev, ...newData }));

    if (currentStep === totalSteps - 1) { // last form step
      // Process STC before final submission
      const finalData = { ...data, ...newData };
      const { formData: updatedFormData, cartItems: updatedCartItems } = processSTC(finalData);

      // Create payload with updated data and cart items
      const payLoad = { ...updatedFormData, cartItems: updatedCartItems };

      // Dispatch with updated data
      setTimeout(() => {
        axiosPrivate.post('/api/order/create', JSON.stringify(payLoad))
          .then((response) => {
            if (response.status === 200) {
              setSeqno(response.data);
              setCartItems([]);
              toast.success(`Your order #${response.data} has been completed.`);
            }
          })
          .catch((err) => {
            let message = '';
            if (err.response?.status === 401) {
              message = "Order Failed to process correctly. Your session has expired and you were logged out.";
            } else {
              message = "Order Failed to process correctly. Please notify our office if this problem persists.\n " + err.message;
            }
            setMessage(message);
            toast.error("Your order submission has failed. Please try again.");
            setCartItems([]);
            console.error("create order error: ", err.response?.data);
          })
          .finally(() => {
            setCurrentStep(prev => prev + 1);
          });
      }, 100);
    } else {
      // Process STC when moving from step 1 to step 2 (after delivery details are set)
      if (currentStep === 1 && newData.trading_stc === '1') {
        const updatedData = { ...data, ...newData };
        processSTC(updatedData);
      }
      setCurrentStep(prev => prev + 1);
    }
  }

  const handlePrevStep = (newData) => {
    setCurrentStep(prev => prev - 1);
    setData(prev => ({ ...prev, ...newData }));
    setTotalSteps(steps.length - 1);
  }

  let steps = [
    <CheckOutForm1 next={handleNextStep} data={data} setData={setData} />,
    // <CheckOutForm2 next={handleNextStep} prev={handlePrevStep} data={data} setData={setData} />,
    <TradingStc next={handleNextStep} prev={handlePrevStep} data={data} setData={setData} />,
    <CheckOutForm3 next={handleNextStep} prev={handlePrevStep} message={message} seqno={seqno} />
  ];

  //Splice out TradingStc form-step if not trading stc's
  if (data.trading_stc === '0') {
    steps.splice(1, 1);
  }

  useEffect(() => {
    setTotalSteps(steps.length - 1);
    if (cartItems?.length) {
      cartItems.sort((a, b) => b.price * b.quantity - a.price * a.quantity);
    }
  }, [steps.length, cartItems]);

  return (
    <Container>

      <ToastContainer />
      {cartItems.length > 0 ?
        <Row>
          <Col xs={12} sm={12} md={8}>

            <Fragment>
              <Stepper activeStep={currentStep} sx={{ mb: '40px' }}>
                <Step completed={currentStep > 0}>
                  <StepLabel>Order Details</StepLabel>
                </Step>
                {/* <Step completed={currentStep > 1}>
                  <StepLabel>Order Details</StepLabel>
                </Step> */}
                {
                  data.trading_stc === '1' ?
                    <Step completed={currentStep > 2}>
                      <StepLabel>Trading Details</StepLabel>
                    </Step>
                    : null
                }
                <Step completed={currentStep === totalSteps}>
                  <StepLabel>Completion</StepLabel>
                </Step>
              </Stepper>

              {steps[currentStep]}
            </Fragment>


          </Col>
          <Col xs={12} sm={12} md={4}>
            <CartCheckOutList itemsInCart={cartItems} cartQuantity={cartQuantity} />
          </Col>
        </Row>
        : currentStep === totalSteps ?
          /* cart this empty but still show order complete page cleaver mick!*/
          <Fragment>{steps[currentStep]}</Fragment>
          :
          <div style={{ margin: 'auto auto', }} className="text-center">
            <h2>Checkout Cart Empty</h2>
            <p>Your cart is empty. Please head to the <Link title="Product page" to="/products">products</Link> page and add
              some items.</p>
          </div>
      }

      {/*<p>CurrentStep: {currentStep} | TotalSteps: {totalSteps} Trading:{data.trading_stc}</p>*/}

    </Container>
  );
}